{
  "entities": {
    "warehouses": "Entrepôt | Entrepôts",
    "loadtypes": "Type de Chargement | Types de Chargement",
    "organizations": "Organisation | Organisations",
    "orgs": "Org | Orgs"
  }
}
